module.exports = "/_next/static/images/UDJ2-a8c4108c6aa0e9ac62ad6b94c96d83d5.svg";